<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3166_81039)">
<rect x="1.945" y="6.85" width="18.11" height="8.3" rx="4.15" stroke="currentColor" stroke-width="1.7"/>
</g>
<defs>
<clipPath id="clip0_3166_81039">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
